import "./HeroBackground.css";

export default function HeroBackground() {
  return (
    <div className="hero-bg">

      {/* Grid */}
      <div className="grid"></div>

      {/* Floating Mechanical Icons */}

      <svg className="icon arm arm1" viewBox="0 0 100 100">
        <g stroke="#2D8CFF" strokeWidth="2.5" fill="none">
          <line x1="20" y1="20" x2="50" y2="40"/>
          <line x1="50" y1="40" x2="70" y2="25"/>
          <circle cx="20" cy="20" r="4"/>
          <circle cx="50" cy="40" r="4"/>
          <circle cx="70" cy="25" r="4"/>
          <line x1="70" y1="25" x2="85" y2="45"/>
          <circle cx="85" cy="45" r="4"/>
        </g>
      </svg>

      <svg className="icon gear gear1" viewBox="0 0 100 100">
        <g stroke="#ffffff" fill="none" strokeWidth="2">
          <circle cx="50" cy="50" r="20"/>
          <circle cx="50" cy="50" r="6"/>
          <path d="M50 10V20M50 80V90M10 50H20M80 50H90M22 22L30 30M70 70L78 78M78 22L70 30M22 78L30 70"/>
        </g>
      </svg>

      <svg className="icon conveyor" viewBox="0 0 200 100">
        <g stroke="#2D8CFF" strokeWidth="2" fill="none">
          <rect x="20" y="40" width="160" height="20" rx="8"/>
          <circle cx="35" cy="50" r="6"/>
          <circle cx="165" cy="50" r="6"/>
        </g>
      </svg>

      <svg className="icon robot" viewBox="0 0 120 120">
        <g stroke="#ffffff" strokeWidth="2" fill="none">
          <rect x="35" y="30" width="50" height="40" rx="5"/>
          <circle cx="50" cy="50" r="3"/>
          <circle cx="70" cy="50" r="3"/>
          <line x1="60" y1="20" x2="60" y2="30"/>
          <circle cx="60" cy="18" r="2"/>
          <line x1="25" y1="45" x2="35" y2="45"/>
          <line x1="85" y1="45" x2="95" y2="45"/>
          <line x1="45" y1="70" x2="45" y2="90"/>
          <line x1="75" y1="70" x2="75" y2="90"/>
        </g>
      </svg>

      {/* Glow */}
      <div className="glow glow1"></div>
      <div className="glow glow2"></div>

    </div>
  );
}